<template>
  <div>
    <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <input type="checkbox" value="Visible" id="checkbox" v-model="isPublic"/>
            Should the package be public?<br>
        </div>
      </div>
      <div class="card-footer">
      <button type="button" class="btn btn-success float-right" @click="saveAccess">
        Save
      </button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    pkg: Object
  },
  watch: {
    async pkg() {
      await this.readData();
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      isPublic: false,
    };
  },
  methods: {
    async readData() {
      const response = await this.axios.get(`/packages/${this.pkg.name}`);
      this.isPublic = response.data.public;
    },
    async saveAccess() {
      try {
        await this.axios.put(`/packages/${this.pkg.name}`, {
          access: this.isPublic ? "public" : "private"
        });
        this.alertStatus = "success";
        this.alertMessage = "Information has been updated";
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    if (this.pkg.name !== "") {
      await this.readData();
    }
  }
};
</script>
